import { ReactNode } from 'react';

import { Icon } from '@/components/icon';
import { Tooltip } from '@/components/tooltip';

import styles from './warning.module.scss';

type WarningProps = {
  title: ReactNode;
  description: ReactNode;
};
const Warning = (props: WarningProps) => (
  <div className={styles.warning}>
    <Tooltip placement="bottom" content={props.description}>
      <div className={styles.warningHeader}>
        <Icon name="AlertTriangle" size={24} />
        {props.title}
      </div>
    </Tooltip>
  </div>
);

export const DataWarning = () => (
  <Warning
    title="Unable to display full data"
    description={
      <>
        Unable to display full chart data due to too many data points.
        <br /> Consider adding a filter or adjusting grouping options.
      </>
    }
  />
);

export const AggregationWarning = () => (
  <Warning
    title="Data needs to be aggregated"
    description="Duplicate entries found. Please aggregate the values to see the full data."
  />
);
